import { useCallback } from 'react';
import {
  Box,
  HStack,
  Icon,
  Select,
  Spacer,
  Spinner,
  Tag,
  TagLabel,
  Text,
  Wrap,
  WrapItem,
} from '@chakra-ui/react';
import { FaSort } from 'react-icons/all';
import { getUpdatedObjectFilterSortingParams } from '../../../services/Objects/SortingService';
import { ObjectsParams } from '../../../types/ParamsTypes';

export interface ObjectsListTopBarProps {
  numberOfBookings: number;
  isReloading: boolean;
  objectsParams: ObjectsParams;
  onFilterChange: (objectsParams: ObjectsParams) => void;
}

export const TopBar = (props: ObjectsListTopBarProps): JSX.Element => {
  const { numberOfBookings, isReloading, objectsParams, onFilterChange } = props;

  const handleChange = useCallback(
    (value: string) => {
      const result = getUpdatedObjectFilterSortingParams(objectsParams, value);
      onFilterChange(result);
    },
    [objectsParams, onFilterChange],
  );

  return (
    <HStack
      pl={0}
      pr={0}
      bg={'white'}
      borderRadius={4}
      alignItems={'center'}
      justify={'space-between'}
      width={'100%'}>
      <Wrap w={'100%'}>
        <WrapItem w={16} alignItems={'center'}>
          <Tag colorScheme={'whatsapp'} size={'lg'}>
            <TagLabel minW={8} textAlign={'center'}>
              {isReloading && (
                <Spinner
                  thickness='2px'
                  speed='0.65s'
                  emptyColor='gray.100'
                  color='green.400'
                  size='xs'
                />
              )}
              {!isReloading && numberOfBookings}
            </TagLabel>
          </Tag>
        </WrapItem>
        <WrapItem alignItems={'center'}>
          <Text>Ferienobjekte gefunden</Text>
        </WrapItem>
        <Spacer />
        <WrapItem
          alignItems={'center'}
          w={{ sm: '100%', md: 'inherit%', lg: 'inherit', xl: 'inherit' }}>
          <Select
            onChange={e => handleChange(e.currentTarget.value)}
            size={'sm'}
            icon={<Icon as={FaSort} fontSize={'md'} />}
            iconColor='blue.500'>
            <option value=''>Nach Empfehlung</option>
            <option value='price_asc'>Preis aufsteigend</option>
            <option value='price_desc'>Preis absteigend</option>
          </Select>
        </WrapItem>
      </Wrap>
    </HStack>
  );
};
